module.exports = __webpack_public_path__ + "static/img/contract.98456d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/order/style/img/contract.jpg
// module id = yzLO
// module chunks = 1